import angular from 'angular';

export const upperFirstChar = (string: string) => {
  if (string && string.length > 0) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return '';
};

export const getNameFromFullname = (string: string) => {
  if (string && string.length > 0 && string.includes(' ')) {
    return string.slice(0, string.indexOf(' '));
  }

  return string;
};

export const hideMiddleName = (string: string) => {
  if (string.match(/\s/g)?.length === 2) {
    const arr = string.split(' ');

    return `${arr[0]} ${arr[2]}`;
  }

  return string;
};

export const contains = (array: any[], item: any) => {
  if (array) {
    return array.indexOf(item) > -1;
  }

  return false;
};

export const isEmpty = (object: { [key: string]: any }) =>
  angular.equals({}, object);

export const formatNumber = (
  value: number,
  {
    precision,
  }: {
    /**
     * How much numbers after comma to display (the fraction size)
     */
    precision?: number;
  } = {},
) =>
  // TODO: we can come up with a better formatting (possibly component)
  // however NumberFormat is a closest and simplest analog of angularjs number filter
  new Intl.NumberFormat(
    'uk-UA',
    typeof precision === 'number'
      ? {
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        }
      : undefined,
  )
    .format(value)
    // intl will format in the following way: 123 456,78
    // We would like to use dot instead of comma
    .replace(',', '.');

/**
 * Why This Works Accurately:
 *
 * - `^` and `$` : Anchors the match to the **entire string**. If there is any trailing or leading garbage text, it fails.
 * - `(?:https?:\/\/)?` : Safely ignores the protocol if present.
 * - `(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+` : This matches each subdomain layer (e.g., `foo.`, `bar.`). The nested logic `[a-z0-9-]*[a-z0-9]` prevents domains from starting or ending with a hyphen (which is invalid per DNS standards). The trailing `+` allows this to repeat for infinite subdomain levels.
 * - `[a-z]{2,}` : Enforces a text-only TLD of at least two characters (e.g., `.de`, `.com`), filtering out standalone IP addresses.
 * - `(?:\/[^\s]*)?` : Matches the remaining path or query string, strictly forbidding spaces (`[^\s]`).
 *
 * ```
 * // Test cases
 * console.log(strictUrlRegex.test("foo.bar.baz.de")); // true
 * console.log(strictUrlRegex.test("://google.com")); // true
 * console.log(strictUrlRegex.test("google.com")); // true
 *
 * // Invalid cases (Now correctly rejected)
 * console.log(strictUrlRegex.test("foo bar baz")); // false
 * console.log(strictUrlRegex.test("192.168.1.1")); // false
 * console.log(strictUrlRegex.test("localhost")); // false
 * console.log(strictUrlRegex.test("-domain.com")); // false
 * ```
 */
export const isValidUrl = (str: any) =>
  /^(?:https?:\/\/)?(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(?:\/[^\s]*)?$/i.test(
    str,
  );

export const hasEmail = (str: any) =>
  /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(
    str,
  );
